import { useQuery } from '@tanstack/react-query';

import { getExchangeRate } from './exchangeRate';
import { ExpenseFormType } from '@/pages/register/expenses/types';

const EXCHANGE_RATE_KEY = 'ExchangeRate';

export const useGetExchangeRate = (
  fromCurrencyIsoCode: string | undefined,
  toCurrencyIsoCode: string | undefined,
  dateString: string, // Changed from Date to string for stable query key
  expenseType: ExpenseFormType,
) => {
  // backend is using employee / project expense type
  const expenseTypeParam =
    expenseType === 'personal' ? 'employee' : expenseType;

  const { data, ...restProps } = useQuery({
    queryKey: [
      EXCHANGE_RATE_KEY,
      fromCurrencyIsoCode,
      toCurrencyIsoCode,
      dateString,
      expenseTypeParam,
    ],
    queryFn: () =>
      getExchangeRate(
        fromCurrencyIsoCode!,
        toCurrencyIsoCode!,
        dateString,
        expenseTypeParam,
      ),
    enabled:
      !!fromCurrencyIsoCode &&
      !!toCurrencyIsoCode &&
      !!dateString &&
      !!expenseTypeParam,
  });

  return { data, ...restProps };
};
